import { GridColDef }               from '@mui/x-data-grid-pro';
import { formatString, getOptions } from '@shared/commonFunctions';
import { dataGridCol }              from '@shared/components/grid/common';
import { statesList }               from '@shared/constants/statesList';
import { IAllUsers }                from '@shared/interfaces';
import { SelectAutocompleteField }  from '@shared/fields/SelectAutocompleteField';
import { IUser }                    from './interfaces';

export const stateUsersFormConfig = (users?: IAllUsers) => [
  {
    width: '100%',
    name: 'state',
    label: 'State',
    options: statesList,
    component: SelectAutocompleteField,
  },
  {
    width: '100%',
    name: 'users',
    label: 'Users',
    options: getOptions(users?.groupUsers || [], 'userId', 'userName'),
    multiple: true,
    component: SelectAutocompleteField,
  },
];

export const stateUsersColumns: GridColDef[] = [
  dataGridCol('state', {
    minWidth: 150,
    headerName: 'State',
  }),
  dataGridCol('users', {
    minWidth: 600,
    valueFormatter: ({ value }) => value?.map((user: IUser) => formatString(user.userName))?.join(', '),
  }),
].map((column) => ({ flex: 1, ...column}));
